<template>
  <div class="modalcontent">
    <div v-if="!off" class="interno">
      <img src="./../../assets/images/LuqueAlerta.svg" alt="" />
      <h2 class="h1-default">¿Estás seguro que deseas salir?</h2>
      <div class="footerPrimerModal">
        <BtnBComponent texto="Cancelar" @click="cerrar" />
        <BtnBComponent texto="Aceptar" @click="cerrarSesion" />
      </div>
    </div>
    <div v-else class="internodos">
      <ThemedIcon name="LuqueLogoNegro" class="imagenlogoCierre" alt="Luque" />
      <div style="margin: auto">
        <h2 class="h1-default" style="color: var(--color-success)">
          ¡Gracias por visitarnos!
        </h2>
        <p class="p-base">Recordá que estamos aquí para ayudarte.</p>
      </div>
    </div>
  </div>
</template>
<script>
import BtnBComponent from "../Buttons/BtnBComponent.vue";
import ThemedIcon from "../Utils/ThemedIcon.vue";

export default {
  name: "ModalOffComponent",
  data() {
    return {
      off: false,
    };
  },
  props: {
    cerrar: Function,
  },
  methods: {
    dispatchOutLogin() {
      this.$store.dispatch("mockOutAction");
    },
    clearCookies() {
      // Elimina todas las cookies registradas en el dominio actual
      const cookies = document.cookie.split(";");
      for (const cookie of cookies) {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie =
          name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
      }
    },
    logOf() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      // cualquier otro dato de sesión

      sessionStorage.clear();

      this.clearCookies();

      this.dispatchOutLogin();

      window.dispatchEvent(
        new CustomEvent("token-localstorage-changed", {
          detail: { storage: null },
        }),
      );

      this.$router.push("/login");
    },
    cerrarSesion() {
      this.off = true;
      setTimeout(() => {
        this.logOf();
      }, 2000);
    },
  },
  components: {
    BtnBComponent,
    ThemedIcon,
  },
};
</script>
<style scoped>
.modalcontent {
  padding: var(--gap30) var(--gapH30);
  height: var(--heightModal);
  width: var(--widthModal);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.interno {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--gap25);
}
.interno img {
  height: auto;
  width: 7.32vw;
}

.interno h2 {
  color: var(--text-primary);
}
.internodos {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--gap30);
  text-align: center;
}
.asd {
  margin-top: 24px;
}
.b {
  display: block;
}

.footerPrimerModal {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1.75vw;
}

.imagenlogoCierre {
  width: 16.1vw;
  height: 11.16vh;
  margin: auto;
}

p {
  color: var(--text-primary);
}
@media (max-width: 770px) {
  .modalcontent {
    width: 100%;
    height: 100%;
    padding: var(--gap20) var(--gapHM15);
  }
  .h2-default {
    font-size: 18px !important;
    font-weight: 600 !important;
  }
  .p-base {
    font-size: 14px !important;
    font-weight: 400 !important;
  }
  .interno {
    gap: 0px;
  }
  .interno img {
    height: 40px;
    width: 40px;
    margin-bottom: var(--gap10);
  }
  .interno h2 {
    width: 90%;
    margin: auto;
    text-align: center;
  }
  .footerPrimerModal {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--gap10);
    margin-top: var(--gap20);
  }
  .internodos {
    gap: var(--gap10);
    height: 100%;
    width: 100%;
  }
  .imagenlogoCierre {
    width: 58%;
    height: 50px;
    margin: auto;
    margin-bottom: var(--gap20);
  }
}
</style>
